import { Route } from "react-router";
import CompanyAdmin from "../components/pages/CompanyAdmin";
import HomePage from "../components/pages/HomePage";
import MyAccount from "../components/pages/MyAccount";
import MyServices from "../components/pages/MyServices";
import React from "react";

const NonAdminRoutes = (
  <React.Fragment>
    <Route path="/" element={<HomePage />} />
    <Route
      data-testid="companyAdminRoute"
      path="/companyAdmin"
      element={<CompanyAdmin />}
    />
    <Route
      data-testid="myAccountRoute"
      path="/myAccount"
      element={<MyAccount />}
    />
    <Route
      data-testid="myServicesRoute"
      path="/myServices"
      element={<MyServices />}
    />
  </React.Fragment>
);

export default NonAdminRoutes;
